export enum SignersType {
	OPERATOR = 'IR1',
	CUSTOMER = 'richiedente1'
}

export enum DossierType {
	START,
	SIGN,
	COMPLETE,
	LAST
}


export enum DossierStatusEnum {
	IR_PROCESS_COMPLETED = 'IR_PROCESS_COMPLETED',
	SIGNATURE_PROCESS_COMPLETED = 'SIGNATURE_PROCESS_COMPLETED',
	ABORTED = 'ABORTED'
}
